var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.335 65.6701C51.4693 65.6701 66.1701 50.9693 66.1701 32.8351C66.1701 14.7008 51.4693 0 33.335 0C15.2007 0 0.5 14.7008 0.5 32.8351C0.5 50.9693 15.2007 65.6701 33.335 65.6701Z",
    fill: "#F5F5F5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.5098,
    y: 21.8896,
    width: 36.9003,
    height: 21.89,
    rx: 1.4433,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4599 19.459C52.7437 19.4617 53.0241 19.5203 53.2852 19.6314C53.5463 19.7425 53.7829 19.904 53.9816 20.1066C54.1803 20.3092 54.3372 20.5489 54.4432 20.8121C54.5492 21.0753 54.6024 21.3568 54.5996 21.6405V43.613C54.601 44.1834 54.3769 44.7311 53.9761 45.1369C53.5752 45.5426 53.0302 45.7734 52.4599 45.7789H15.1485C14.5782 45.7734 14.0332 45.5426 13.6324 45.1369C13.2315 44.7311 13.0074 44.1834 13.0088 43.613V21.6405C13.0074 21.0702 13.2315 20.5224 13.6324 20.1167C14.0332 19.711 14.5782 19.4802 15.1485 19.4747L52.4599 19.459Z",
    stroke: "#572580",
    strokeWidth: 2.16495
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9365 40.4121H23.9371",
    stroke: "#572580",
    strokeWidth: 2.16495
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8203 35.3604H48.8512",
    stroke: "#572580",
    strokeWidth: 2.16495
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9316 40.4121H31.9322",
    stroke: "#572580",
    strokeWidth: 2.16495
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9258 40.4121H39.9264",
    stroke: "#572580",
    strokeWidth: 2.16495
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9238 40.4121H47.9244",
    stroke: "#572580",
    strokeWidth: 2.16495
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0771 25.2578H49.0777",
    stroke: "#572580",
    strokeWidth: 2.16495
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackCard);
export default __webpack_public_path__ + "static/media/back-card.17dc502582ff0bcbb5d3f12ecbbe417a.svg";
export { ForwardRef as ReactComponent };